import React from "react";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";

import Icon from "./Icon";
import { loginUser, logoutUser } from "../actions/Users";
import { connect } from "react-redux";
import { setHistoryRoute, setRoute } from "../actions";
import Access from "./Access";
import Modal from "./Modal";
import { translations } from "../config";

const mapStateToProps = ( state ) =>
{
	return {
		messages: state.messages,
		user: state.user,
		route: state.route,
		isFetching: state.isFetching
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		resetRoute: () =>
		{
			dispatch( setRoute( null ) );
			// dispatch( setHistoryRoute( null ) );
		},
		setHistoryRoute: ( a_route ) =>
		{
			dispatch( setHistoryRoute( a_route ) );
		},
		loginUser: ( formData ) =>
		{
			dispatch( loginUser( formData ) );
		},
		logoutUser: () =>
		{
			dispatch( logoutUser() );
		}
	};
};

class AuthForm extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			email: null,
			password: null,
			modalVisible: false
		};
		
		this.handleEdit = this.handleEdit.bind( this );
		this.handleLoginUser = this.handleLoginUser.bind( this );
		this.handleLogoutUser = this.handleLogoutUser.bind( this );
		
	} // function constructor(...)
	
	componentDidUpdate()
	{
		if ( this.props.route !== null )
		{
			this.setState( { email: null, password: null } );
			this.props.history.push( this.props.route );
			this.props.resetRoute();
		}
		
		// Nach dem erfolgreichem Einloggen werden Email/Passwort aus dem State entfernt
		if ( Access.isPermitted( this.props.user, [ "user_permissions" ] ) && ( this.state.email !== null || this.state.password !== null ) )
		{
			this.setState( {
				email: null,
				password: null
			} );
		}
		
	} // function componentDidUpdate(...)
	
	handleEdit( event )
	{
		this.setState( { [ event.target.name ]: event.target.value } );
		
	} // function handleEdit(...)
	
	handleLoginUser( event )
	{
		event.preventDefault();
		
		this.props.setHistoryRoute( this.props.location.pathname );
		this.props.history.push( "/" );
		this.props.loginUser( { email: this.state.email, password: this.state.password } );
		
	} // function handleLoginUser(...)
	
	handleLogoutUser( event )
	{
		event.preventDefault();
		
		this.props.logoutUser();
		this.props.history.push( "/" );
		
	} // function handleLogoutUser(...)
	
	handleModalVisibleState( a_state )
	{
		if ( this.state.modalVisible === a_state )
		{
			this.setState(
				{
					modalVisible: !a_state
				}
			);
		}
		
	} // function handleModalVisibleState(...)
	
	render()
	{
		switch ( this.props.type )
		{
			case "smart":
				return [
					<Access key={"smartLoginModal"} permissions={[ "guest_user_permissions" ]}>
						<Modal title={"Kundenlogin"}
						       trigger={
							       <div className={"tRight"}>
								       <button className={"btn-flat primary-color-text hover-secondary-color-text"} title={"Anmelden"}>
									       <Icon size={36} key={"user-icon"} iconName={"user"}/>
								       </button>
							       </div>
						       }
						       footer={
							       <React.Fragment>
								       <button aria-label="Anmelden" data-modal={"confirm"} onClick={this.handleLoginUser}>
									       <Icon key={`login-user-icon`} iconName={"user"}/><span key={`login-user-text`}>Anmelden</span>
								       </button>
								       <button className={"secondary-color"} data-modal={"close"}>Abbrechen</button>
							       </React.Fragment>
						       }
						>
							<form className={"col s12 login-form smartLoginModal margin-top margin-bottom unset-padding"} onSubmit={this.handleLoginUser}>
								<input aria-label="Login/E-Mail" name="email" type="email" placeholder={"Login/E-Mail"} onChange={this.handleEdit}/>
								<input aria-label="Passwort" name="password" type="password" placeholder={"Passwort"} onChange={this.handleEdit}/>
								<button className={"hidden"} type={"submit"}/>
							</form>
						</Modal>
					</Access>,
					<Access key={"smartLogout"} permissions={[ "user_permissions" ]}>
						<div className={"tRight"}>
							<button className={"btn-flat primary-color-text hover-secondary-color-text"} title={"Abmelden"} onClick={this.handleLogoutUser}>
								<Icon size={36} key={`logout-user-icon`} iconName={"logout"}/>
							</button>
						</div>
					</Access>
				];
			case "tiny":
				return [
					<Access key={"tinyLoginModal"} permissions={[ "guest_user_permissions" ]}>
						<Modal className={"tinyAuth"}
						       title={<h4 className={"secondary-color-text unset-padding-top"}>Kundenlogin</h4>}
						       overflow={false}
						       onIsVisible={this.handleModalVisibleState.bind( this )}
						       trigger={
							       <div className={"tRight"}>
								       <button className={"btn-flat light-grey-text hover-secondary-color-text"} title={"Anmelden"}>
									       <Icon size={36} iconName={"user"}/><Icon verticalAlign={"text-top"} iconName={`${this.state.modalVisible ? "moveUp" : "moveDown"}`}/>
								       </button>
							       </div>
						       }
						       footer={
							       <React.Fragment>
								       <button aria-label="Anmelden" data-modal={"confirm"} onClick={this.handleLoginUser}>
									       <Icon key={`login-user-icon`} iconName={"user"}/><span key={`login-user-text`}>Anmelden</span>
								       </button>
								       <button className={"secondary-color"} data-modal={"close"}>Abbrechen</button>
							       </React.Fragment>
						       }
						>
							<form className={"col s12 login-form smartLoginModal margin-top margin-bottom unset-padding"} onSubmit={this.handleLoginUser}>
								<input aria-label="Login/E-Mail" name="email" type="email" placeholder={"Login/E-Mail"} onChange={this.handleEdit}/>
								<input aria-label="Passwort" name="password" type="password" placeholder={"Passwort"} onChange={this.handleEdit}/>
								<button className={"hidden"} type={"submit"}/>
							</form>
						</Modal>
						<div className={"col s12 tRight absolute position bottom right"}>
							<Icon iconName={"register"} verticalAlign={"baseline"}/> <NavLink
							to={translations.de_DE.routes.registration}>Neu {translations.de_DE.words.toRegistrate}?</NavLink>
						</div>
					</Access>,
					<Access key={"tinyLogout"} permissions={[ "user_permissions" ]}>
						<div className={"col s12 logout-form position bottom right"}>
							<h4 className={"tRight"}>
								{`Hallo ${this.props.user.sex === "m" ? "Herr " : this.props.user.sex === "m" ? "Frau " : ""}
								${this.props.user.forename} ${this.props.user.surname}`}
							</h4>
							<div>
								<div className={"valign-wrapper"}>
									<p className={"col s12 tRight unset-padding"}>
										<span className={"col s12 l4 grey-text"}>Organisation</span>
										<span className={"col s12 l8 unset-padding-right"}>{this.props.user.organization && this.props.user.organization.name}</span>
									</p>
								</div>
							</div>
							<div>
								<div className={"valign-wrapper"}>
									<div className={"col s12 tRight unset-padding"}>
										<span className={"col s12 l4 btn-text-middle"}><NavLink to="/passwort-aendern">Passwort ändern</NavLink></span>
										<span className={"col s12 l8 unset-padding"}>
											<button className={"right unset-margin light-grey secondary-color-text"}
											        onClick={this.handleLogoutUser}
											>
												<Icon key={`logout-user-icon`} iconName={"logout"}/><span key={`logout-user-text`}>Abmelden</span>
											</button>
										</span>
									</div>
								</div>
							</div>
						</div>
					</Access>
				];
			default:
				return [
					<Access key={"login"} permissions={[ "guest_user_permissions" ]}>
						<form className={"col s12 login-form position bottom right"} onSubmit={this.handleLoginUser}>
							<h4>Kundenlogin</h4>
							<input aria-label="Login/E-Mail" name="email" type="email" placeholder={"Login/E-Mail"} onChange={this.handleEdit}/>
							<input aria-label="Passwort" name="password" type="password" placeholder={"Passwort"} onChange={this.handleEdit}/>
							<div className={"valign-wrapper"}>
								<span className={"col s12 block-padding"}><NavLink to="/passwort-vergessen">Passwort vergessen?</NavLink></span>
								<span className={"col s12 unset-padding"}>
									<button className={"right"}
									        type={"submit"}
									        aria-label={"Anmelden"}
									        onClick={this.handleLoginUser}
									>
										<Icon key={`login-user-icon`} iconName={"user"}/><span key={`login-user-text`}>Anmelden</span>
									</button>
								</span>
							</div>
							<div>Neu <NavLink to={translations.de_DE.routes.registration}>{translations.de_DE.words.toRegistrate}</NavLink>?</div>
						</form>
					</Access>,
					<Access key={"logout"} permissions={[ "user_permissions" ]}>
						<div className={"col s12 logout-form position bottom right"}>
							<h4 className={"tRight"}>
								{`Hallo ${this.props.user.sex === "m" ? "Herr " : this.props.user.sex === "m" ? "Frau " : ""}
								${this.props.user.forename} ${this.props.user.surname}`}
							</h4>
							<div>
								<div className={"valign-wrapper"}>
									<p className={"col s12 tRight unset-padding"}>
										<span className={"col s12 l4 grey-text"}>Organisation</span>
										<span className={"col s12 l8 unset-padding-right"}>{this.props.user.organization && this.props.user.organization.name}</span>
									</p>
								</div>
							</div>
							<div>
								<div className={"valign-wrapper"}>
									<div className={"col s12 tRight unset-padding"}>
										<span className={"col s12 l4 btn-text-middle"}><NavLink to="/passwort-aendern">Passwort ändern</NavLink></span>
										<span className={"col s12 l8 unset-padding"}>
											<button className={"right unset-margin"}
											        onClick={this.handleLogoutUser}
											>
												<Icon key={`logout-user-icon`} iconName={"logout"}/><span key={`logout-user-text`}>Abmelden</span>
											</button>
										</span>
									</div>
								</div>
							</div>
						</div>
					</Access>
				];
		}
		
	} // function render()
	
} // class

AuthForm.propTypes = {
	type: PropTypes.string
};

AuthForm = connect(
	mapStateToProps,
	mapDispatchToProps
)( AuthForm );

export default withRouter( AuthForm );